import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function Payment() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">{t("REPORTS.PAYMENT")}</td>
			<td className="table--bets__dd u-color--offer--lose">
				{bet.displayPayment}
			</td>
		</tr>
	);
});
